<template lang="">
  <div>
    <div class="grid grid-cols-6 gap-y-6 gap-x-4">
      <v-label class="col-start-1 col-span-6 md:col-span-3" title="IBAN">
        <v-input
          v-model="bank.iban"
          :name="prefix + '-iban'"
          type="text"
          autocomplete="off"
          placeholder="DE00 0000 0000 0000 0000 00"
          :error="computedIbanErrorMessage"
          @blur="validateIban"
        />
        <p v-if="lookupPending" class="mt-1 text-sm text-gray-500">Bankdaten werden ermittelt …</p>
      </v-label>

      <v-label class="col-span-6 md:col-span-3" title="Kontoinhaber">
        <v-input
          v-model="bank.owner"
          :name="prefix + '-owner'"
          :error="ownerError"
          type="text"
        />
      </v-label>
    </div>

    <div class="grid grid-cols-6 gap-y-6 gap-x-4 mt-4">
      <v-label class="col-start-1 col-span-6 md:col-span-3" title="Bankname">
        <v-input
          v-model="bank.bankName"
          :name="prefix + '-bankname'"
          type="text"
          class="bg-gray-200"
          disabled
        />
      </v-label>
      <v-label class="col-span-6 md:col-span-3" title="BIC">
        <v-input
          v-model="bank.bic"
          :name="prefix + '-bic'"
          type="text"
          class="bg-gray-200"
          disabled
        />
      </v-label>
    </div>
  </div>
</template>
<script>
import VInput from '../components/v-input.vue';
import VLabel from '../components/v-label.vue';

/**
 * Bankverbindung (IBAN + Kontoinhaber, BIC und Bankname werden ermittelt).
 *
 * modelValue: { iban, owner, bic, bankName }
 * validation: Vuelidate-Knoten mit den Regeln für iban und owner
 * serverErrors: Meldungen des Servers für iban/owner (überlagern Vuelidate)
 */
export default {

  components: {
    VInput,
    VLabel,
  },

  emits: ['update:modelValue'],

  props: {
    modelValue: { type: Object, required: true },
    validation: { type: Object, default: null },
    serverErrors: { type: Object, default: () => ({}) },
    token: { type: String, default: '' },
    prefix: { type: String, default: 'bank' },
  },

  data() {
    return {
      bank: {
        iban: this.modelValue.iban || '',
        owner: this.modelValue.owner || '',
        bic: this.modelValue.bic || '',
        bankName: this.modelValue.bankName || '',
      },
      ibanErrorMessage: null,
      lookupPending: false,
    }
  },

  computed: {
    computedIbanErrorMessage(){
      if(this.serverErrors && this.serverErrors.iban){
        return this.serverErrors.iban
      }
      if(this.ibanErrorMessage){
        return this.ibanErrorMessage
      }
      if(this.validation && this.validation.iban){
        return this.validation.iban.$errors[0] || null
      }
      return null
    },

    ownerError(){
      if(this.serverErrors && this.serverErrors.owner){
        return this.serverErrors.owner
      }
      if(this.validation && this.validation.owner){
        return this.validation.owner.$errors[0] || null
      }
      return null
    },
  },

  watch: {
    bank: {
      deep: true,
      handler(){
        this.$emit('update:modelValue', {
          iban: this.bank.iban,
          owner: this.bank.owner,
          bic: this.bank.bic,
          bankName: this.bank.bankName,
        })
      },
    },
  },

  methods: {
    validateIban(){
      const iban = (this.bank.iban || '').replace(/\s+/g, '').toUpperCase()
      // Lesbar gruppieren; der Server entfernt die Leerzeichen wieder.
      this.bank.iban = iban.replace(/(.{4})/g, '$1 ').trim()

      if(!iban){
        this.ibanErrorMessage = null
        this.bank.bic = ''
        this.bank.bankName = ''
        return
      }

      const data = new FormData()
      data.append('token', this.token)
      data.append('iban', iban)
      this.lookupPending = true

      fetch('/api.php?action=iban', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
      .then((response) => response.ok ? response.json() : null)
      .then((json) => {
        if(!json){
          // Prüfung gerade nicht möglich: Eingabe stehen lassen, der Server prüft beim Absenden erneut.
          this.ibanErrorMessage = null
          return
        }
        if(!json.valid){
          this.ibanErrorMessage = 'Diese IBAN ist ungültig.'
          this.bank.bic = ''
          this.bank.bankName = ''
          return
        }
        this.ibanErrorMessage = null
        this.bank.bic = json.bic || ''
        this.bank.bankName = json.bank_name || ''
      })
      .catch(() => {
        this.ibanErrorMessage = null
      })
      .then(() => {
        this.lookupPending = false
      })
    }
  },
}
</script>
<style lang="">

</style>